import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";
import { HeroSection } from "@/components/home/HeroSection";
import { TrustSection } from "@/components/home/TrustSection";
import { WhySection } from "@/components/home/WhySection";
import { RegularizacionSection } from "@/components/home/RegularizacionSection";
import { HowItWorksSection } from "@/components/home/HowItWorksSection";
import { PricingSection } from "@/components/home/PricingSection";
import { AISection } from "@/components/home/AISection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { BlogPreviewSection } from "@/components/home/BlogPreviewSection";
import { CTASection } from "@/components/home/CTASection";

const Index = () => {
  return (
    <Layout>
      <SEO
        title="SinConta | Contador en Línea desde $350/mes"
        description="Contador en línea en México: declaraciones SAT, RESICO, honorarios, Uber, Didi y freelancers. Contadores reales potenciados por IA."
        canonical="/"
      />
      <HeroSection />
      <TrustSection />
      <WhySection />
      <RegularizacionSection />
      <HowItWorksSection />
      <PricingSection />
      <AISection />
      <TestimonialsSection />
      <BlogPreviewSection />
      <CTASection />
    </Layout>
  );
};

export default Index;
